module.exports = __webpack_public_path__ + "81d4e6ec4f29f95458c037310029c5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/solutions/images/bg.png
// module id = 983
// module chunks = 3